// external types
import type { GetSwiggyHeadersResponsePayload } from "@swiggy-private/native-bridge";

// external constants
import { DEFAULT_ANALYTICS_CONTEXT_VALUE } from "@swiggy-private/analytics";

// external types
import Analytics from "@swiggy-private/analytics";
import type { AnalyticsConfig } from "@swiggy-private/analytics/dist/interfaces";

// internal constants
import { ANALYTICS_HOST } from "./constants";
import { IEventPayload } from "./types";

export function safeStringify<T = unknown>(obj: T, defaultValue = "-"): string {
    try {
        const stringifiedValue = JSON.stringify(obj);
        return typeof stringifiedValue === "string" ? stringifiedValue : defaultValue;
    } catch (e) {
        return defaultValue;
    }
}

export const getAnalyticsConfigFromHeaders = (
    headers: GetSwiggyHeadersResponsePayload | undefined,
    isDevelopment = true
): AnalyticsConfig => {
    return {
        apiHost: isDevelopment ? "" : ANALYTICS_HOST,
        userInfo: {
            deviceId: headers?.deviceId || "-",
            sid: headers?.sid || "-",
            tid: headers?.tid || "-",
            userId: headers?.userId || "-",
        },
        userLocation: { lat: headers?.lat || "", lng: headers?.lng || "" },
        platform: headers?.platform || "Swiggy-Mweb",
        appVersionCode: headers?.["version-code"] || "-",
    };
};

export const getAnalyticsEvents = (analyticsConfig: AnalyticsConfig | undefined) => {
    const analyticsEvents =
        (analyticsConfig && new Analytics(analyticsConfig)) || DEFAULT_ANALYTICS_CONTEXT_VALUE;
    return analyticsEvents;
};

export const sendEvent = ({
    eventFn,
    screenName,
    objectName,
    objectValue,
    objectPosition,
    context,
    extraParams,
}: IEventPayload) => {
    eventFn({
        category: screenName || "-",
        action: objectName || "-",
        label: objectValue || "-",
        value: objectPosition || "-",
        context: context || "-",
        extraParams: safeStringify(extraParams, "-"),
    });
};
